<template>

    <div class="col-12 payments-page">

        <div class="card card-outline card-secondary">

<!-- Encabezado -->

            <div class="card-header">

                <div class="d-flex flex-wrap align-items-center justify-content-between">

                    <div>

                        <h3 class="card-title mb-0">

                            <i class="fa-solid fa-money-check-dollar mr-2"></i>

                            Lista de Pagos

                        </h3>

                        <br>

                        <small class="text-muted d-block mt-1">

                            Consulta, filtra y administra los movimientos registrados.

                        </small>

                    </div>

                    <div class="card-tools mt-2 mt-md-0 payments-actions">

                        <button type="button" class="btn btn-sm btn-outline-primary" @click="newPayment"

                            v-can="'banking_services_pay'">

                            <i class="fa fa-plus mr-1"></i>

                            Nuevo pago

                        </button>

                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="downloadFiles()">

                            <i class="fa-solid fa-box-archive mr-1"></i>

                            Archivo de facturas

                        </button>

                        <button type="button" class="btn btn-sm btn-outline-success"

                            v-if="authUser.organization_charts_id !== 2 && authUser.organization_charts_id !== 5"

                            @click="exportData()">

                            <i class="fa fa-file-excel mr-1"></i>

                            Aviso de pago

                        </button>

                    </div>

                </div>

            </div>

            <div class="card-body">

                <!-- Filtros -->

                <section class="filters-panel">

                    <div class="d-flex align-items-center justify-content-between mb-3 filters-heading">

                        <h6 class="mb-0 font-weight-bold">

                            <i class="fa-solid fa-filter mr-1"></i>

                            Filtros

                        </h6>

                        <span v-if="init" class="default-period-badge">

                            <i class="fa-regular fa-calendar mr-1"></i>

                            Periodo predeterminado

                        </span>

                    </div>

                    <div class="row filters-grid">

                        <div class="col-md-7 col-lg-8">

                            <label>Buscar</label>

                            <div class="search-input-wrapper"><i class="fa-solid fa-magnifying-glass"></i><input

                                    class="form-control" v-debounce:2s="list" type="search" v-model="search_all"

                                    placeholder="Buscar por ID, proveedor, concepto, folio o descripción"></div>

                        </div>

                        <div class="col-md-5 col-lg-4">

                            <label>Rango de fechas</label>

                            <date-picker format="YYYY-MM-DD" valueType="format" :range="true" v-model="search.date"

                                class="date-filter"></date-picker>

                        </div>

                        <div class="col-md-4 mt-2" v-if="authUser.organization_charts_id != 2">

                            <label>Empresa</label>

                            <select v-model="search.company_id" class="form-control">

                                <option value="">Todas las empresas</option>

                                <option v-for="(company, index) in catalogue.companies_buildings" :key="index"

                                    :value="company.id"> {{ company.name }}

                                </option>

                            </select>

                        </div>

                        <div class="col-md-4 mt-2">

                            <label>Tipo</label>

                            <select type="text" class="form-control" v-model="search.type_id">

                                <option value="">Todos los tipos</option>

                                <option value="1">Presupuestos</option>

                                <option value="2">Gasto recurrente</option>

                            </select>

                        </div>

                        <div class="col-md-4 mt-2" v-if="authUser.organization_charts_id != 2">

                            <label>Usuario</label>

                            <select type="text" class="form-control" v-model="search.user_id">

                                <option value="">Todos los usuarios</option>

                                <option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">

                                    {{ user.name }} {{ user.last_name }}</option>

                            </select>

                        </div>

                        <div class="col-md-4 mt-2">

                            <label>Propiedad</label>

                            <select type="text" class="form-control" v-model="search.building_id">

                                <option value="">Todas las propiedades</option>

                                <option v-for="(building, index) in catalogue.buildings" :value="building.id"

                                    :key="index">

                                    {{ building.name }}

                                </option>

                            </select>

                        </div>

                        <div class="col-md-4 mt-2">

                            <label>Categoría</label>

                            <select type="text" class="form-control" v-model="search.concept_id">

                                <option value="">Todas las categorías</option>

                                <option v-for="(concept, index) in catalogue.concepts" :value="concept.id" :key="index">

                                    {{ concept.name }}</option>

                            </select>

                        </div>

                        <div class="col-md-4 mt-2">

                            <label>Tipo de saldo</label>

                            <select type="text" class="form-control" v-model="search.type_payment_id">

                                <option value="">Todos los tipos de saldo</option>

                                <option v-for="(type_payment, index_type_payment) in catalogue.type_payments"

                                    :value="type_payment.id" :key="index_type_payment">{{

                                        type_payment.name }}</option>

                            </select>

                        </div>

                        <div class="col-md-4 mt-2">

                            <label>Tipo de factura</label>

                            <select class="form-control" v-model="search.biill_type_id">

                                <option value="">Todos los tipos de factura</option>

                                <option v-for="(type, index) in catalogue.bills_types" :value="type.id" :key="index">{{

                                    type.name }}</option>

                            </select>

                        </div>

                        <div class="col-md-4 mt-2" v-if="authUser.organization_charts_id != 2">

                            <label>Razón social</label>

                            <select class="form-control" v-model="search.billing_data_id">

                                <option value="">Todas las razones sociales</option>

                                <option v-for="(type, index) in catalogue.all_billing_data" :value="type.id"

                                    :key="index">

                                    {{ type.business_name }} - {{ type.rfc }}

                                </option>

                            </select>

                        </div>

                        <div class="col-md-4 mt-3">

                            <button class="btn mt-4 btn-block complement-filter"

                                :class="search.complement == 1 ? 'active' : ''"

                                @click=" search.complement = search.complement == 1 ? '' : '1'">

                                <i class="fa-solid fa-circle-info"></i><span>Sin complemento de pago</span>

                            </button>

                        </div>

                        <!-- <div class="col-md-4 mt-3">

                        <button class="btn mt-4 btn-block btn-outline-secondary"

                            :class="search.pay_roll == 1 ? 'active' : ''"

                            @click=" search.pay_roll = search.pay_roll == 1 ? '' : '1'">

                            <i class="fa-solid fa-file-invoice fa-lg text-info"></i> - Nominas

                        </button>

                    </div> -->

                        <div class="col-md-4 mt-3">

                            <label>Entregas</label>

                            <select class="form-control" v-model="search.delivery_id">

                                <option value="">Todas las entregas</option>

                                <option value="1">Entrega completa</option>

                                <option value="2">Falta entrega</option>

                            </select>

                        </div>

                    </div>

                </section>

                <!-- Resumen -->

                <section class="payments-summary" aria-label="Resumen de pagos">

                    <div class="summary-card summary-total">

                        <div class="summary-icon"><i class="fa-solid fa-list-check"></i></div>

                        <div>

                            <span>Total mostrado</span>

                            <strong>{{ pays.total || 0 }}</strong>

                        </div>

                    </div>

                    <div class="summary-card summary-amount">

                        <div class="summary-icon"><i class="fa-solid fa-wallet"></i></div>

                        <div>

                            <span>Monto total</span>

                            <strong>{{ sumdata()[0] | toCurrency }}</strong>

                        </div>

                    </div>

                    <div class="summary-card summary-pending">

                        <div class="summary-icon"><i class="fa-solid fa-clock"></i></div>

                        <div>

                            <span>Por pagar</span>

                            <strong>{{ sumdata()[1] | toCurrency }}</strong>

                        </div>

                    </div>

                    <div class="summary-card summary-paid">

                        <div class="summary-icon"><i class="fa-solid fa-circle-check"></i></div>

                        <div>

                            <span>Pagado</span>

                            <strong>{{ sumdata()[2] | toCurrency }}</strong>

                        </div>

                    </div>

                </section>

                <!-- Tabla -->

                <section class="table-container results-panel">

                    <div class="table-responsive payments-table-wrapper">

                        <table class="table table-bordered table-hover text-center text-sm payments-table">

                            <thead>

                                <tr>

                                    <th class="id-column">ID</th>

                                    <th class="data-column">Información del pago</th>

                                    <th class="amount-column">Monto</th>

                                    <th class="amount-column">Por pagar</th>

                                    <th class="amount-column">Pagado</th>

                                    <th class="date-column">Fechas de pago</th>

                                    <th class="actions-column text-center">Acciones</th>

                                </tr>

                            </thead>

                            <tbody v-if="load">

                                <tr>

                                    <td align="center" colspan="7" class="table-state">

                                        <div class="loading-state">

                                            <i class="fa-solid fa-circle-notch fa-spin"></i>

                                            <h5>Cargando pagos</h5>

                                            <p>Estamos consultando la información.</p>

                                        </div>

                                    </td>

                                </tr>

                            </tbody>

                            <tbody v-else-if="pays.total > 0">

                                <tr class="payment-row" :class="buy.id == selected ? 'selected' : ''"

                                    v-for="(buy, index) in pays.data" :key="index">

                                    <td class="payment-id-cell" data-label="ID">

                                        <span class="payment-id">#{{ buy.id }}</span>

                                        <!-- <div class="d-inline mt-3" v-if="buy.bill">

                                        <div class="d-inline" v-if="showItem(buy)">

                                            <i v-if="buy.bill.supplements.map(({pivot}) => pivot).map(({amount}) => amount).reduce((a,b) => a + b, 0) < buy.bill.amount && !buy.bill.complement_xml"

                                                class="fa-solid fa-circle-info text-info fa-xl  fa-fade"></i>

                                        </div>

                                    </div> -->

                                        <div class="d-inline mt-3" v-if="buy.bill">

                                            <div class="d-inline" v-if="showItem(buy)">

                                                <i v-if="buy.bill.supplements

                                                    && buy.bill.supplements.map(({ pivot }) => pivot)

                                                        .map(({ amount }) => amount)

                                                        .reduce((a, b) => a + b, 0) < buy.bill.amount" class="fa-solid fa-circle-info text-info fa-xl fa-fade">

                                                </i>

                                            </div>

                                        </div>

                                    </td>

                                    <td class="text-left payment-data-cell" data-label="Información del pago">

                                        <span v-if="buy.banking_service_payment_id">

                                            <strong>Pago con reglas</strong><br>

                                            <strong>Tipo de pago : </strong>

                                            <span v-if="buy.banking_service_payment">

                                                Pago cuenta bancaria

                                            </span>

                                            <span v-else>

                                                Pago a proveedor

                                            </span>

                                            <br>

                                        </span>

                                        <span v-if="buy.payroll_id">

                                            Nomina

                                            <hr>

                                            <strong>Fecha : </strong>

                                            {{ buy.pay_roll.date | toDateTime }}<br>

                                            <strong>Compañía : </strong>

                                            {{ buy.pay_roll.company.name }}<br>

                                            <strong>Fecha inicio : </strong>

                                            {{ buy.pay_roll.date_start | toDateTime }}<br>

                                            <strong>Fecha fin : </strong>

                                            {{ buy.pay_roll.date_end | toDateTime }}<br>

                                            <!-- <strong>Dispersión : </strong>

                                        {{ buy.pay_roll.dispersion == 1 ? 'Si' : 'No' }}<br> -->

                                            <strong>Monto : </strong>

                                            {{ buy.pay_roll.amount | toCurrency }}<br>

                                        </span>

                                        <!-- Pago con reglas -->

                                        <div v-else-if="buy.banking_service_payment_id && !buy.bill"

                                            >

                                            <hr>

                                            <template v-if="buy.banking_service_payment">

                                                <div class="bank-payment-header">

                                                    <div class="bank-icon">

                                                        <i class="fas fa-university"></i>

                                                    </div>

                                                    <div class="bank-payment-title">

                                                        <span class="bank-payment-label">Cuenta bancaria</span>

                                                        <strong>

                                                            {{

                                                                buy.banking_service_payment.bank_account

                                                                    ? buy.banking_service_payment.bank_account.name

                                                                    : 'Sin cuenta bancaria'

                                                            }}

                                                        </strong>

                                                    </div>

                                                </div>

                                                <div class="bank-payment-badges">

                                                    <span class="payment-badge payment-badge-category">

                                                        <i class="fas fa-tag"></i>

                                                        {{

                                                            buy.banking_service_payment.concept

                                                                ? buy.banking_service_payment.concept.name

                                                                : 'Sin categoría'

                                                        }}

                                                    </span>

                                                    <span class="payment-badge payment-badge-movement">

                                                        <i class="fas fa-exchange-alt"></i>

                                                        {{

                                                            buy.banking_service_payment.type_payment

                                                                ? buy.banking_service_payment.type_payment.name

                                                                : 'Sin tipo de movimiento'

                                                        }}

                                                    </span>

                                                </div>

                                                <template v-if="buy.banking_service_payment.bank_account">

                                                    <div class="bank-payment-grid">

                                                        <div class="bank-payment-item">

                                                            <span class="bank-payment-label">Banco</span>

                                                            <strong>

                                                                {{

                                                                    buy.banking_service_payment.bank_account.bank

                                                                        ? buy.banking_service_payment.bank_account.bank.name

                                                                        : 'Sin banco'

                                                                }}

                                                            </strong>

                                                        </div>

                                                        <div class="bank-payment-item">

                                                            <span class="bank-payment-label">Tipo de cuenta</span>

                                                            <strong>

                                                                {{

                                                                    buy.banking_service_payment.bank_account.type_account_bank

                                                                        ?

                                                                        buy.banking_service_payment.bank_account.type_account_bank.name

                                                                        : 'Sin tipo de cuenta'

                                                                }}

                                                            </strong>

                                                        </div>

                                                        <div class="bank-payment-item">

                                                            <span class="bank-payment-label">Cuenta</span>

                                                            <strong

                                                                v-if="buy.banking_service_payment.bank_account.number"

                                                                class="masked-account" :title="'Terminación ' + getLastFour(

                                                                    buy.banking_service_payment.bank_account.number

                                                                )">

                                                                •••• {{ getLastFour(

                                                                    buy.banking_service_payment.bank_account.number

                                                                ) }}

                                                            </strong>

                                                            <span v-else class="empty-value">

                                                                Sin cuenta

                                                            </span>

                                                        </div>

                                                        <div class="bank-payment-item">

                                                            <span class="bank-payment-label">CLABE</span>

                                                            <strong

                                                                v-if="buy.banking_service_payment.bank_account.number_bis"

                                                                class="masked-account" :title="'Terminación ' + getLastFour(

                                                                    buy.banking_service_payment.bank_account.number_bis

                                                                )">

                                                                •••• {{ getLastFour(

                                                                    buy.banking_service_payment.bank_account.number_bis

                                                                ) }}

                                                            </strong>

                                                            <span v-else class="empty-value">

                                                                Sin CLABE

                                                            </span>

                                                        </div>

                                                    </div>

                                                </template>

                                                <div v-else class="bank-payment-empty">

                                                    No se encontró la información de la cuenta bancaria.

                                                </div>

                                            </template>

                                            <div v-else class="bank-payment-empty">

                                                <i class="fas fa-exclamation-circle"></i>

                                                Sin información del pago bancario.

                                            </div>

                                        </div>

                                        <!--  -->

                                        <!-- otros -->

                                        <span v-else>

                                            <!-- Tipo -->

                                            <span v-if="buy.type_id == 1"> Presupuesto </span>

                                            <span v-else-if="buy.type_id == 2"> Gasto recurrente </span>

                                            <span v-else-if="buy.type_id == 3"> Pago desde chequera </span>

                                            <br>

                                            <!-- Proveedor -->

                                            <strong>Usuario : </strong>

                                            <span v-if="buy.provider"> {{ buy.provider.name }} {{ buy.provider.last_name

                                            }}</span>

                                            <span v-else>Sin usuario</span>

                                            <br>

                                            <!-- Concepto -->

                                            <strong>Concepto : </strong>

                                            <span v-if="buy.bill"> {{ buy.bill.name }}</span>

                                            <span v-else>Sin Concepto</span>

                                            <br>

                                            <!-- Empresa -->

                                            <strong>Empresa: </strong>

                                            <span v-if="buy.bill">

                                                <span v-if="buy.bill.company">

                                                    {{ buy.bill.company.name }}

                                                </span>

                                            </span>

                                            <span v-else>Sin Empresa</span>

                                            <br>

                                            <!-- Tipo -->

                                            <strong>Tipo de movimiento : </strong><br>

                                            <span v-if="buy.type_payment"> {{ buy.type_payment.name }}

                                                <span class="badge badge-info" v-if="buy.pay.length > 0">

                                                    {{ buy.pay[0].folio }}

                                                </span>

                                            </span>

                                            <span v-else>Sin tipo</span>

                                            <br>

                                            <!-- Categoría -->

                                            <strong>Categoría : </strong>

                                            <span v-if="buy.concept"> {{ buy.concept.name }}</span>

                                            <span v-else>Sin categoría</span><br>

                                            <div v-if="buy.pending_delivery == 1 && !buy.complete_delivery_date">

                                                <strong>Pendiente de entrega: </strong>

                                                <span v-if="buy.pending_delivery == 1 && !buy.complete_delivery_date">

                                                    Si

                                                </span>

                                            </div>

                                            <div v-if="buy.pending_delivery == 1 && buy.complete_delivery_date">

                                                <strong>Entrega completa: </strong><br>

                                                {{ buy.complete_delivery_date | toDateTime }} |

                                                <a v-if="buy.evidence_delivery" target="_blank"

                                                    style="padding: 5px 10px;"

                                                    :href="`${globalUrlFiles}${buy.evidence_delivery}`"

                                                    class="btn m-1 badge badge-success btn-sm">

                                                    <i class="fas fa-file"></i> Evidencia

                                                </a>

                                            </div>

                                            <hr>

                                            <strong>Datos de facturación </strong>

                                            <br>

                                            <span v-if="buy.bill">

                                                <small

                                                    :class="(buy.bill.validated == 'I' ? 'bg-danger' : (buy.bill.validated == 'P' ? 'bg-warning' : (buy.bill.validated == 'N' ? 'bg-secondary' : 'bg-success')))"

                                                    class="btn_now badge badge-secondary">

                                                    {{ buy.bill.validated | statusType }}

                                                </small>

                                            </span>

                                            <br>

                                            <!-- Razón social -->

                                            <span v-if="buy.bill">

                                                <span v-if="buy.bill.user_bill">

                                                    {{ buy.bill.user_bill.business_name }}

                                                </span>

                                                <span v-else>Sin Razón social</span>

                                            </span>

                                            <span v-else>Sin Razón social</span>

                                            <br>

                                            <!-- Folio Factura -->

                                            <strong>Folio : </strong>

                                            <span v-if="buy.bill">

                                                <span v-if="buy.bill.folio">

                                                    {{ buy.bill.folio }}

                                                </span>

                                                <span v-else>Sin Folio</span>

                                            </span>

                                            <span v-else>Sin Folio</span>

                                            <br>

                                            <!-- RFC -->

                                            <span v-if="buy.bill">

                                                <span v-if="buy.bill.user_bill">

                                                    {{ buy.bill.user_bill.rfc }} |

                                                    <a class="btn btn-info btn-sm" target="_blank"

                                                        v-if="buy.bill.user_bill.cedula"

                                                        :href="`${globalUrlFiles}${buy.bill.user_bill.cedula}`">

                                                        <i class="fa-regular fa-file-pdf"></i> Ver cédula fiscal

                                                    </a>

                                                    <small v-else class="btn_now badge badge-secondary"> Sin caratula

                                                        fiscal</small>

                                                </span>

                                                <span v-else>Sin RFC</span>

                                            </span>

                                            <span v-else>Sin RFC</span>

                                            <br>

                                            <strong>Aprobado por :</strong><br>

                                            <span v-if="buy.bill">

                                                <span v-if="buy.bill.provider">

                                                    {{ buy.bill.provider.name }} {{ buy.bill.provider.last_name }}

                                                </span>

                                                <span v-else>S/D</span>

                                            </span>

                                            <span v-else>S/D</span>

                                            <br>

                                            <!-- complemento de pago -->

                                            <!--<div class="d-inline mt-3" v-if="buy.bill">

                                            <div class="row" v-if="buy.bill.check && buy.bill.biill_type_id == 2">

                                                <div class="col-12">

                                                    <strong>Complemento de pago:</strong><br>

                                                    <a class="btn btn-info btn-sm m-1" v-if="buy.bill.complement_file"

                                                        @click="downloadFile('complement_pdf', buy.bill.id)">

                                                        <i class="fa-regular fa-file-pdf"></i> Complemento PDF

                                                    </a>

                                                    <a class="btn btn-info btn-sm m-1" v-if="buy.bill.complement_xml"

                                                        @click="downloadFile('complement_xml', buy.bill.id)">

                                                        <i class="fa-regular fa-file-pdf"></i> Complemento XML

                                                    </a>

                                                    <span v-else> Sin complemento de pago </span>

                                                </div>

                                            </div>

                                        </div>

                                        -->

                                            <hr>

                                            <strong>Cuenta Bancaria </strong>

                                            <br>

                                            <!-- Banco -->

                                            <span v-if="buy.bill">

                                                <span v-if="buy.bill.bank_account_providers">

                                                    {{ buy.bill.bank_account_providers.bank.name }}

                                                </span>

                                                <span v-else>Sin Banco</span>

                                            </span>

                                            <span v-else>Sin Banco</span>

                                            <br>

                                            <!-- Cuenta -->

                                            <span v-if="buy.bill">

                                                <span v-if="buy.bill.bank_account_providers">

                                                    {{ buy.bill.bank_account_providers.clue_number }} |

                                                    <a class="btn btn-info btn-sm" target="_blank"

                                                        v-if="buy.bill.bank_account_providers.file"

                                                        :href="`${globalUrlFiles}${buy.bill.bank_account_providers.file}`">

                                                        <i class="fa-regular fa-file-pdf"></i> Ver caratula de banco

                                                    </a>

                                                    <small v-else class="btn_now badge badge-secondary"> Sin caratula de

                                                        banco</small>

                                                </span>

                                                <span v-else>Sin Cuenta</span>

                                            </span>

                                            <span v-else>Sin Cuenta</span>

                                            <br>

                                            <!-- Concepto -->

                                            <strong>Concepto : </strong>

                                            <span v-if="buy.bill"> {{ buy.bill.name }}</span>

                                            <span v-else>Sin Concepto</span>

                                            <br>

                                            <!-- Moneda -->

                                            <strong>Moneda : </strong>

                                            <span v-if="buy.bill">

                                                <span v-if="buy.bill.currency_id"> {{ buy.bill.currency.name }}</span>

                                                <span v-else>S/D</span>

                                            </span>

                                            <span v-else>S/D</span>

                                            <br>

                                            <!-- Descripción -->

                                            <strong>Descripción : </strong>

                                            <span v-if="buy.bill"> {{ buy.bill.description }}</span>

                                            <span v-else>Sin Descripción</span>

                                            <br>

                                        </span>

                                    </td>

                                    <td class="text-right payment-amount-cell" data-label="Monto" v-if="buy.currency_id == 2">

                                        {{ (parseFloat(buy.amount) + parseFloat(buy.credit)) * buy.exchange | toCurrency

                                        }}

                                        <br>

                                        {{ (buy.amount + buy.credit) | toCurrency }} USD

                                    </td>

                                    <td class="text-right payment-amount-cell" data-label="Monto" v-else>

                                        {{ (buy.amount + buy.credit) | toCurrency }}

                                    </td>

                                    <td class="text-right payment-amount-cell amount-payable-cell" data-label="Por pagar"

                                        v-if="buy.currency_id == 2">

                                        <strong>{{ buy.amount_payable * buy.exchange | toCurrency

                                        }}</strong>

                                        <br>

                                        <strong style="font-weight: 900;">{{ buy.amount_payable | toCurrency }}

                                            USD</strong>

                                    </td>

                                    <td class="text-right payment-amount-cell amount-payable-cell" data-label="Por pagar" v-else>

                                        <strong>{{ buy.amount_payable | toCurrency }}</strong>

                                    </td>

                                    <td class="text-right payment-amount-cell amount-paid-cell" data-label="Pagado"

                                        v-if="buy.currency_id == 2">

                                        {{ buy.sum_pays * buy.exchange | toCurrency }}

                                        <br>

                                        {{ buy.sum_pays | toCurrency }} USD

                                    </td>

                                    <td class="text-right payment-amount-cell amount-paid-cell" data-label="Pagado" v-else>

                                        {{ buy.sum_pays | toCurrency }}

                                    </td>

                                    <td class="payment-date-cell" data-label="Fechas de pago">

                                        <span v-if="buy.bill">

                                            <span v-if="buy.bill.check">

                                                <span v-if="buy.bill.check.pay">

                                                    <span v-for="(pay, index_pay) in buy.bill.check.pay"

                                                        :key="index_pay">

                                                        {{ pay.date | toDateTime }}

                                                    </span>

                                                </span>

                                            </span>

                                        </span>

                                        <span v-else-if="buy.type_id == 3 || buy.pay_roll">

                                            <span v-for="(pay, index_pay) in buy.pay" :key="index_pay">

                                                {{ pay.date | toDateTime }}

                                            </span>

                                        </span>

                                        <span v-else-if="buy.banking_service_payment_id">

                                            {{ buy.banking_service_payment.payment_date | toDateTime }}

                                        </span>

                                        <span v-else>

                                            S/F

                                        </span>

                                    </td>

                                    <!-- <td>

                                    <span v-if="buy.pay"> {{ buy.pay.user_approved.name }} {{

                                        buy.pay.user_approved.last_name }}</span>

                                    <span v-else>Sin Usuario</span>

                                </td>

                                <td>

                                    <span v-if="buy.pay"> {{ buy.pay.authorization_date | toDateTime }} </span>

                                    <span v-else>Sin Fecha</span>

                                </td> -->

                                    <td class="text-center actions-cell" data-label="Acciones">

                                        <div class="actions-wrap">

                                            <button v-if="buy.bill"

                                                @click="formDataBill(buy.bill, buy.user_approved, buy.pay)"

                                                class="btn btn-outline-secondary m-1 btn-sm">

                                                <i class="fa-solid fa-receipt mr-1"></i> Ver Factura

                                            </button>



                                            <button v-if="buy.type_id == 1" @click="showBudget(buy.budget.id)"

                                                type="button" class="btn btn-sm  m-1 btn-outline-light ">

                                                <i class="fa-solid fa-coins mr-1"></i>Ver presupuesto

                                            </button>

                                            <div class="d-inline" v-if="buy.buy">

                                                <button v-if="buy.type_id == 2 && buy.buy.payment_period_id !== 5"

                                                    @click="viewPay(buy.buy_id)" type="button"

                                                    class="btn btn-sm  m-1 btn-outline-light ">

                                                    <i class="fa-solid fa-basket-shopping mr-1"></i>Ver compra

                                                    recurrente

                                                </button>

                                                <button v-if="buy.type_id == 2 && buy.buy.buy_id"

                                                    @click="viewPay(buy.buy.buy_id)" type="button"

                                                    class="btn btn-sm  m-1 btn-outline-light ">

                                                    <i class="fa-solid fa-basket-shopping mr-1"></i>Ver compra

                                                    recurrente

                                                </button>

                                            </div>

                                            <!-- <button @click="formData(buy)" v-can="'edit_pays'"

                                        class="btn btn-outline-primary m-1 btn-sm">

                                        <i class="fas fa-edit "> </i> Editar

                                    </button> -->



                                            <button type="button" v-if="buy.pay.length == 1"

                                                @click="deleted(buy.pay[0].id)" v-can="'deleted_pays'"

                                                class="btn-outline-danger btn m-1 btn-sm ">

                                                <i class="fa fa-trash"></i> Eliminar

                                            </button>

                                            <!-- <button @click="formDataPays(buy, buy.pay)" v-can="'add_pays'" class="btn m-1 btn-sm btn-outline-warning">

                                        <i class="fa-solid fa-hand-holding-dollar mr-1"> </i>

                                        <span>Ver pago</span>

                                    </button> -->

                                            <button @click="formListPays(buy)"

                                                class="btn m-1 btn-sm btn-outline-warning">

                                                <i class="fa-solid fa-hand-holding-dollar mr-1"> </i>

                                                <span>Ver pago</span>

                                            </button>

                                            <div class="d-inline" v-if="buy.bill">

                                                <button type="button" v-if="buy.type_payment_id == 5 && buy.signature"

                                                    @click="downloadRecibe(buy.id)"

                                                    class="btn m-1 btn-outline-info btn btn-sm ">

                                                    <i class="fa-solid fa-file-pdf"></i> Recibo de pago

                                                </button>

                                                <button type="button" v-can="'approve_pays'"

                                                    v-if="buy.type_payment_id == 5 && !buy.signature"

                                                    @click="addSignature(buy)"

                                                    class="btn m-1 btn-outline-secondary btn btn-sm ">

                                                    <i class="fa-solid fa-signature"></i> Firmar pago

                                                </button>



                                                <a v-if="buy.bill.file" :href="`${globalUrlFiles}${buy.bill.file}`"

                                                    target="_blank" class="btn m-1 btn-outline-secondary btn-sm">

                                                    <i class="fas fa-file-pdf "> </i> Archivo PDF

                                                </a>

                                                <button v-if="buy.bill.xml" class="btn m-1 btn-outline-secondary btn-sm"

                                                    @click="downloadFile('xml', buy.bill.id)">

                                                    <i class="fas fa-file "> </i> Archivo XML

                                                </button>

                                                <div class="d-inline" v-if="buy.bill">

                                                    <div class="d-inline"

                                                        v-if="buy.bill.check && buy.bill.biill_type_id == 2">

                                                        <button type="button" v-if="buy.bill.check.pay"

                                                            @click="newPaymentPlugin(buy.bill)" class="btn m-1 btn-sm "

                                                            :class="(buy.bill.supplements.map(({ pivot }) => pivot).map(({ amount }) => amount).reduce((a, b) => a + b, 0) >= buy.bill.amount || buy.bill.complement_xml) ? 'btn-outline-success' : 'btn-outline-warning'">

                                                            <i class="fa-solid fa-comments-dollar"></i>

                                                            <span

                                                                v-if="buy.bill.supplements.map(({ pivot }) => pivot).map(({ amount }) => amount).reduce((a, b) => a + b, 0) >= buy.bill.amount || buy.bill.complement_xml">

                                                                Ver complemento(s) de pago de la factura

                                                            </span>

                                                            <span v-else> Agrega complemento de pago a la factura</span>

                                                        </button>

                                                    </div>

                                                </div>

                                                <div class="d-inline" v-if="buy.bill">

                                                    <button type="button" v-if="buy.bill" @click="showChecks(buy.bill)"

                                                        class="btn m-1 btn-outline-success btn btn-sm ">

                                                        <i class="fa-solid fa-receipt"></i> Ver cheques de la factura

                                                    </button>

                                                    <button @click="newCredit(buy.bill, buy.bill.credit)"

                                                        v-if="buy.bill.credit" class="btn m-1 btn-sm btn-outline-info">

                                                        <i class="fa-solid fa-comment-dollar mr-1"></i>Ver nota de

                                                        crédito

                                                    </button>

                                                </div>

                                                <div class="d-inline" v-if="buy.bill">

                                                    <button type="button" v-if="buy.bill.pety_cash"

                                                        @click="showPettyCash(buy.bill.pety_cash)"

                                                        class="btn m-1 btn-outline-success btn btn-sm ">

                                                        <i class="fa-solid fa-cash-register"></i> Ver movimiento

                                                    </button>

                                                </div>

                                            </div>

                                            <div class="d-inline" v-if="buy.bill">

                                                <button v-if="buy.bill.biill_type_id == 4" v-can="'edit_bill'"

                                                    @click="formDataBill(buy.bill, buy.user_approved, buy.pay, true)"

                                                    class="btn btn-outline-info m-1 btn-sm">

                                                    <i class="fa-solid fa-edit mr-1"></i> Editar factura

                                                </button>

                                            </div>

                                            <hr>

                                            <div class="d-inline" v-if="buy.bill">

                                                <button v-for="(pay, index) in buy.pay" :key="index"

                                                    @click="getVoucher(pay.id)" class="btn btn-outline-info m-1 btn-sm">

                                                    <i class="fa-solid fa-file-pdf mr-1"></i> Aviso de pago

                                                </button>

                                            </div>

                                            <button v-if="buy.pending_delivery == 1 && !buy.complete_delivery_date"

                                                @click="completeDelivery(buy.id)"

                                                class="btn m-1 btn-outline-success btn btn-sm ">

                                                <i class="fas fa-shipping-fast"></i> Entrega completa

                                            </button>

                                        </div>

                                    </td>

                                </tr>

                            </tbody>

                            <tbody v-else>

                                <tr>

                                    <td align="center" colspan="7" class="table-state">

                                        <div class="empty-state">

                                            <i class="fa-regular fa-folder-open"></i>

                                            <h5>Sin resultados</h5>

                                            <p>Prueba cambiando o eliminando alguno de los filtros.</p>

                                        </div>

                                    </td>

                                </tr>

                            </tbody>

                            <tfoot v-if="pays.total > 0 && load == false">

                                <tr class="totals-row">

                                    <td colspan="2">

                                        Total :

                                    </td>

                                    <td class="text-right" data-label="Monto">

                                        {{ sumdata()[0] | toCurrency }}

                                    </td>

                                    <td class="text-right" data-label="Por pagar">

                                        {{ sumdata()[1] | toCurrency }}

                                    </td>

                                    <td class="text-right" data-label="Pagado">

                                        {{ sumdata()[2] | toCurrency }}

                                    </td>

                                    <td colspan="2"></td>

                                </tr>

                            </tfoot>

                        </table>

                    </div>

                    <div class="pagination-wrapper" v-if="pays">

                        <pagination v-model="page" :records="pays.total" :per-page="pays.per_page" @paginate="list" />

                    </div>

                </section>

            </div>

        </div>

        <!-- Modal pagos -->

        <modal name="SelectPay" v-bind:click-to-close="false" :width="'400px'" :height="'auto'"

            class="payment-type-modal">

            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i

                    class="fa-solid fa-xmark"></i> </button>

            <div class="modal-header">

                <div>

                    <h5 class="modal-title" id="exampleModalLabel">Selecciona el tipo de pago</h5>

                    <p class="modal-subtitle">Elige el origen del nuevo movimiento.</p>

                </div>

            </div>

            <div class="modal-body">

                <div class="row">

                    <div class="col-md-6">

                        <button class="btn btn-app payment-option-btn btn-block" @click="openCreateModal()">

                            <i class="fas fa-solid fa-money-check-dollar f-30"></i> Cuenta de banco

                        </button>

                    </div>

                    <div class="col-md-6">

                        <button class="btn btn-app payment-option-btn btn-block" @click="openCreateModalBill()">

                            <i class="fas fa-user f-30"></i> Proveedor

                        </button>

                    </div>

                </div>

            </div>

        </modal>

        <ModalFormComponent :prop_edit="false" />

        <ModalTableComponentPays :prop_edit="false" />

        <ModalFormComponentBill :prop_edit="editBill" />

        <ModalDownloadFiles />

        <ModalFormReceiptComponent />

        <ModalBuysTable />

        <ModalBudgetsTable />

        <ModalBuysRelationComponent />

        <ModalSignatureComponentVue />

        <ModalCredit :prop_edit="false" />

        <ModalChecksBillSummary />

        <ModalFormComponentBudgetsPetty :prop_edit="false" />

        <ModalDeliveryCompleteComponent />

        <ModalFormComponentPayRule />

        <ModalFormRulesComponent />

    </div>

</template>

<script>

import ModalCredit from '@/components/bill/ModalCreditComponent.vue';

import ModalDownloadFiles from '@/components/bill/ModalDownloadFilesComponent.vue';

import ModalFormReceiptComponent from '@/components/pays/ModalFormReceiptComponent.vue';

import ModalFormComponent from '@/components/checks/ModalFormComponent.vue';

import ModalTableComponentPays from '@/components/pays/ModalTableComponent.vue';

import ModalFormComponentBill from '@/components/bill/ModalFormComponent.vue';

import ModalSignatureComponentVue from '@/components/pays/ModalSignatureComponent.vue';

import ModalBuysTable from '@/components/buy/ModalTableComponent.vue'

import ModalBudgetsTable from '@/components/budgets/ModalTableComponent.vue'

import ModalBuysRelationComponent from '@/components/buy/ModalBuysRelationComponent.vue';

import ModalChecksBillSummary from '@/components/checks/ModalChecksBillSummaryComponent.vue'

import ModalFormComponentBudgetsPetty from '@/components/petty_cash/ModalFormPettyCashComponent.vue'

import ModalDeliveryCompleteComponent from '@/components/delivery/ModalDeliveryCompleteComponent.vue';

import { mapMutations, mapActions, mapGetters } from 'vuex';

import Pagination from 'vue-pagination-2';

import request from '@/services/request';

import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/index.css';

import ModalFormComponentPayRule from '@/components/banking_service_payments/ModalBankingServicesPayments.vue';

import ModalFormRulesComponent from '@/components/bill/ModalFormRuleComponent.vue';



export default {

    name: "companies-table",

    components: {

        ModalFormComponent,

        ModalTableComponentPays,

        ModalFormComponentBill,

        ModalDownloadFiles,

        ModalFormReceiptComponent,

        Pagination,

        DatePicker,

        ModalBuysTable,

        ModalBudgetsTable,

        ModalBuysRelationComponent,

        ModalSignatureComponentVue,

        ModalCredit,

        ModalChecksBillSummary,

        ModalFormComponentBudgetsPetty,

        ModalDeliveryCompleteComponent,

        ModalFormComponentPayRule,

        ModalFormRulesComponent

    },

    data() {

        return {

            name: '',

            editBill: '',

            pays: {},

            selected: '',

            trigger: true,

            init: false,

            search: {

                date: '',

                company_id: '',

                paid: 1,

                search: '',

                type_id: '',

                user_id: '',

                concept_id: '',

                biill_type_id: '',

                billing_data_id: '',

                type_payment_id: '',

                complement: '',

                pay_roll: 0,

                delivery_id: '',

                building_id: '',

            },

            search_all: '',

            page: 1,

            catalogue: new Catalogue(),

            load: true,

        }

    },

    filters: {

        statusType(status) {

            switch (status) {

                case "V":

                    return "Válido y Conciliado"

                case "P":

                    return "Pendiente por Proveedor"

                case "I":

                    return "No encontrado en el SAT"

                case "N":

                    return "Pendiente de Conciliar"

                default:

                    return "Estatus no encontrado";

            }

        }

    },

    async mounted() {

        let id = this.$route.query.id;

        if (id) {

            this.search.complement = 1;

        } else {

            await this.list();

        }

        await this.catalogue.get_companies_buildings();

        await this.catalogue.get_users_profile(2);

        await this.catalogue.get_concepts();

        await this.catalogue.get_type_payments();

        await this.catalogue.get_bills_types();

        await this.catalogue.get_all_billing_data();

        await this.catalogue.get_buildings();

        this.setHeaderTitle('Gasto recurrente');

        await this.showSelected(id);

    },

    created() {

        Event.$on("event-load-checks", () => {

            this.list();

        });

        Event.$on("event-load-bills", () => {

            this.list();

        });

    },

    methods: {

        getLastFour(value) {

            if (value === null || value === undefined || value === '') {

                return '';

            }

            const normalizedValue = String(value).replace(/\D/g, '');

            return normalizedValue.slice(-4);

        },

        closedModal() {

            this.$modal.hide('SelectPay');

        },

        openCreateModalBill(payment = {}) {

            this.closedModal();

            Event.$emit('event-show-addBillRules', payment);

        },

        openCreateModal(payment = {}) {

            this.closedModal();

            Event.$emit('event-show-banking-service-payment', payment);

        },

        newPayment() {

            this.$modal.show('SelectPay');

        },

        completeDelivery(id) {

            Event.$emit('event-show-completeDelivery', id);

        },

        getVoucher(id) {

            window.open(this.globalUrlFiles + '/voucherPay/' + id, '_blank');

        },

        showPettyCash(petty = false) {

            Event.$emit('event-show-addPettyCash', petty);

        },

        showItem(item) {

            // Asegúrate de que la fecha se compare correctamente

            let dateCondition = new Date(item.date) >= new Date('2024-07-01');

            return item.bill.check && item.bill.biill_type_id == 2 && dateCondition;

        },

        showChecks(bill = {}) {

            Event.$emit('event-show-listChecksBillsSummary', bill);

        },

        newCredit(bill, credit) {

            Event.$emit('event-show-addBillCredit', bill, credit);

        },

        addSignature(bill = {}) {

            console.log(bill);

            Event.$emit('event-show-addSiganturePay', bill);

        },

        viewPay(id) {

            Event.$emit('event-show-BuysRelationID', id);

            // Event.$emit('event-load-buy', id);

        },

        showSelected(id = false) {

            if (id) {

                this.selected = id;

            } else {

                this.selected = '';

            }

        },

        newPaymentPlugin(bill = {}) {

            console.log(bill);

            Event.$emit('event-show-addPaymentPlugin', bill);

        },

        downloadFiles() {

            let filter = this.search;

            filter.type = 'pays';

            Event.$emit('event-show-downloadFiles', filter);

        },

        sumdata() {

            let sum1 = 0;

            let sum2 = 0;

            let sum3 = 0;

            if (this.pays) {

                this.pays.data.forEach(function (buy) {

                    if (buy.amount) {

                        sum1 += parseFloat(buy.amount) * (buy.currency_id == 2 ? buy.exchange : 1);

                    }

                    if (buy.credit) {

                        sum1 += parseFloat(buy.credit) * (buy.currency_id == 2 ? buy.exchange : 1);

                    }

                    sum2 += parseFloat(buy.amount_payable) * (buy.currency_id == 2 ? buy.exchange : 1);

                    sum3 += parseFloat(buy.sum_pays) * (buy.currency_id == 2 ? buy.exchange : 1);

                });

            }

            return [sum1, sum2, sum3];

        },

        downloadFile(type, id) {

            let url = this.globalUrlFiles + '/bills/download_file?id=' + id + '&type=' + type;

            window.open(url, '_blank');

        },

        showBudget(id) {

            Event.$emit('event-load-budget', id);

        },

        exportData() {

            let filter = this.globalUrlFiles + '/pays/export?' + new URLSearchParams(this.search).toString();

            filter += '&user_login=' + this.authUser.id;

            window.open(filter, '_blank');

        },

        cancelPays(id) {

            let vm = this;

            console.log(id);

            this.$swal({

                title: 'Motivos de Cancelación',

                input: 'text',

                icon: 'warning',

                inputAttributes: {

                    autocapitalize: 'off'

                },

                showCancelButton: true,

                confirmButtonText: 'Guardar',

                showLoaderOnConfirm: true,

                preConfirm: async (message) => {

                    console.log(message);

                    let form = {

                        id: id,

                        message: message,

                    };

                    let _endpoint = '/cancel_pays';

                    try {

                        let { data } = await request.postMedia(_endpoint, form)

                        if (data) {

                            console.log(data);

                            await vm.successNotification(data.message);

                            await vm.list();

                        }

                    } catch (error) {

                        vm.errors = {};

                        if (error.response) {

                            vm.errors = vm.errorNotification(error);

                        }

                    }

                },

                allowOutsideClick: () => !this.$swal.isLoading()

            }).then((result) => {

                if (result.isConfirmed) {

                    console.log(result);

                }

            })

        },

        formData(edit = {}) {

            console.log(edit);

            Event.$emit('event-show-addChecks', edit);

        },

        formDataBill(dta = {}, user_approved = {}, pay = {}, edit = false) {

            console.log(dta);

            this.editBill = edit;

            Event.$emit('event-show-addBill', dta, user_approved, pay);

        },

        formDataPays(check, edit = {}) {

            Event.$emit('event-show-addPays', check, edit);

        },

        formListPays(check) {

            Event.$emit('event-show-listPays', check);

        },

        formDataPaysFast(check) {

            this.$swal({

                title: 'Pago rapido',

                text: 'Se aprobara el pago rapido',

                icon: 'warning',

                showCancelButton: true,

                confirmButtonColor: '#3085d6',

                cancelButtonColor: '#d33',

                confirmButtonText: 'Pagar',

                cancelButtonText: 'Cancelar'

            }).then(async (result) => {

                if (result.isConfirmed) {

                    let form = {

                        check_id: check.id,

                        date: this.moment().format("YYYY-MM-DD"),

                        amount: check.amount,

                        description: 'Pago aprobado'

                    };

                    let _endpoint = '/pays';

                    try {

                        let { data } = await request.postMedia(_endpoint, form)

                        if (data) {

                            console.log(data);

                            this.successNotification(data.message);

                            this.list();

                        }

                    } catch (error) {

                        this.errors = {};

                        if (error.response) {

                            this.errors = await this.errorNotification(error);

                        }

                    }

                }

            });

        },

        deleted: function (id) {

            let tit = 'Eliminar cheque';

            let txt = 'Seguro que quiere eliminar la cheque';

            this.$swal({

                title: tit,

                text: txt,

                icon: 'warning',

                showCancelButton: true,

                confirmButtonColor: '#3085d6',

                cancelButtonColor: '#d33',

                confirmButtonText: 'Ok',

                cancelButtonText: 'Cancelar'

            }).then((result) => {

                if (result.isConfirmed) {

                    this.callDeleted(id);

                }

            });

        },

        approve: function (id) {

            let tit = 'Aprobar Presupuestos';

            let txt = 'Seguro que quiere aprobar el presupuestos';

            this.$swal({

                title: tit,

                text: txt,

                icon: 'warning',

                showCancelButton: true,

                confirmButtonColor: '#3085d6',

                cancelButtonColor: '#d33',

                confirmButtonText: 'Ok',

                cancelButtonText: 'Cancelar'

            }).then(async (result) => {

                if (result.isConfirmed) {

                    let _endpoint = '/pays_approve';

                    let form = {

                        id: id

                    };

                    try {

                        let response = await request.post(_endpoint, form).then(function (response) { return response; });

                        this.list();

                        this.successNotification(response.data.message);

                    } catch (error) {

                        this.errors = await this.errorNotification(error)

                    }

                }

            });

        },

        async callDeleted(id) {

            let _endpoint = '/pays/' + id;

            try {

                let response = await request.destroy(_endpoint).then(function (response) { return response; });

                this.list();

                this.successNotification(response.data.message);

            } catch (error) {

                this.errors = await this.errorNotification(error)

            }

        },

        showImport() {

            this.$modal.show('example');

        },

        async list(page = this.page) {

            this.init = false;

            this.load = true;

            let service = request;

            let search = this.search;

            search.search = this.search_all;

            let _endpoint = '/pays';

            try {

                let { data } = await service.list(_endpoint, page, search)

                if (data) {

                    this.init = this.search.company_id == '' &&

                        this.search.search == '' &&

                        this.search.type_id == '' &&

                        this.search.user_id == '' &&

                        this.search.concept_id == '' &&

                        this.search.biill_type_id == '' &&

                        this.search.billing_data_id == '' &&

                        this.search.type_payment_id == '' &&

                        this.search.complement == '' &&

                        (this.search.date == '' || this.search.date[0] == null) &&

                        this.search.delivery_id == '' &&

                        this.search.building_id == '';

                    this.pays = data.data;

                    if (data.dates[0] != '') {

                        this.trigger = false;

                        this.search.date = data.dates;

                    }

                    this.load = false;

                    this.selected = '';

                }

            } catch (error) {

                console.log(error);

                this.load = false;

            }

        },

        ...mapMutations({

            setHeaderTitle: 'setHeaderTitle',

        }),

        ...mapActions({

            resetPassword: 'auth/resetPass',

            errorNotification: 'alert/error',

            successNotification: 'alert/success',

        }),

    },

    computed: {

        ...mapGetters({

            'authUser': 'auth/user'

        })

    },

    watch: {

        '$route.query': {

            handler: function (params) {

                if (params) {

                    this.showSelected(params.id);

                }

            },

            deep: true,

            immediate: true

        },

        'name': {

            handler: function (val) {

                if (val == '') {

                    this.list();

                }

            },

            deep: true

        },

        "search": {

            handler: function () {

                if (this.trigger)

                    this.list();

                else

                    this.trigger = true;

            },

            deep: true

        }

    }

}

</script>

<style scoped>

.payments-page {

    padding-bottom: 20px;

}

.card-header {

    padding: 16px 20px;

}

.card-title {

    font-size: 18px;

    font-weight: 600;

}

.payments-actions {

    display: flex;

    flex-wrap: wrap;

    gap: 6px;

    align-items: center;

    justify-content: flex-end;

}

.payments-actions .btn {

    white-space: nowrap;

}

/* Filtros */

.filters-panel {

    padding: 18px 18px 3px;

    margin-bottom: 20px;

    background-color: #f8f9fa;

    border: 1px solid #e3e6e9;

    border-radius: 8px;

}

.filters-heading h6 {

    font-size: 16px;

    color: #2f343a;

}

.filters-panel label {

    margin-bottom: 6px;

    font-size: 13px;

    font-weight: 600;

    color: #495057;

}

.filters-grid {

    margin-right: -8px;

    margin-left: -8px;

}

.filters-grid>[class*="col-"] {

    margin-top: 0 !important;

    margin-bottom: 15px;

    padding-right: 8px;

    padding-left: 8px;

}

.filters-panel .form-control,

.filters-panel>>>.mx-input {

    height: 40px;

    font-size: 14px;

    border: 1px solid #ced4da;

    border-radius: 6px;

    background-color: #ffffff;

    box-shadow: none;

}

.filters-panel .form-control:focus,

.filters-panel>>>.mx-input:focus {

    border-color: #80bdff;

    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.08);

}

.search-input-wrapper {

    position: relative;

}

.search-input-wrapper>i {

    position: absolute;

    top: 50%;

    left: 13px;

    z-index: 2;

    color: #6c757d;

    font-size: 13px;

    transform: translateY(-50%);

    pointer-events: none;

}

.search-input-wrapper .form-control {

    padding-left: 36px;

}

.date-filter,

.date-filter>>>.mx-datepicker {

    width: 100%;

}

.default-period-badge {

    display: inline-flex;

    align-items: center;

    padding: 5px 9px;

    color: #856404;

    background-color: #fff3cd;

    border: 1px solid #ffe69c;

    border-radius: 14px;

    font-size: 11px;

    font-weight: 600;

    white-space: nowrap;

}

.complement-filter {

    display: flex;

    align-items: center;

    justify-content: center;

    gap: 6px;

    height: 40px;

    margin-top: 25px !important;

    border: 1px solid #ced4da;

    border-radius: 6px;

    background-color: #ffffff;

    color: #495057;

    font-size: 13px;

    font-weight: 600;

}

.complement-filter:hover {

    color: #0056b3;

    background-color: #f3f7fc;

    border-color: #80bdff;

}

.complement-filter.active {

    color: #0056b3;

    background-color: #e7f1ff;

    border-color: #4b72d9;

}

/* Tarjetas de resumen */

.payments-summary {

    display: grid;

    grid-template-columns: repeat(4, minmax(0, 1fr));

    gap: 17px;

    margin-bottom: 20px;

}

.summary-card {

    display: flex;

    align-items: center;

    min-height: 85px;

    padding: 15px;

    background-color: #ffffff;

    border: 1px solid #e5e7eb;

    border-left: 4px solid #6c757d;

    border-radius: 8px;

    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.04);

}

.summary-icon {

    display: flex;

    align-items: center;

    justify-content: center;

    flex: 0 0 44px;

    width: 44px;

    height: 44px;

    margin-right: 13px;

    font-size: 18px;

    color: #2f343a;

    background-color: #f1f3f5;

    border-radius: 50%;

}

.summary-card span {

    display: block;

    margin-bottom: 1px;

    font-size: 12px;

    color: #6c757d;

    text-transform: uppercase;

    letter-spacing: 0.3px;

}

.summary-card strong {

    display: block;

    font-size: 22px;

    line-height: 1.1;

    color: #212529;

    word-break: break-word;

}

.summary-total {

    border-left-color: #6c757d;

}

.summary-amount {

    border-left-color: #28a745;

}

.summary-pending {

    border-left-color: #ffc107;

}

.summary-paid {

    border-left-color: #4b72d9;

}

/* Tabla */

.table-container {

    overflow: visible;

    border: 1px solid #dee2e6;

    border-radius: 8px;

}

.payments-table-wrapper {

    position: relative;

    height: auto;

    min-height: 0;

    overflow: visible !important;

    overscroll-behavior: auto;

}

.payments-table {

    width: 100%;

    min-width: 0;

    margin-bottom: 0;

    table-layout: fixed;

    border-collapse: separate;

    border-spacing: 0;

}

.payments-table thead th {

    position: sticky;

    top: 0;

    z-index: 20;

    padding: 12px 8px;

    vertical-align: middle;

    font-size: 12px;

    font-weight: 700;

    color: #343a40;

    background-color: #f1f3f5;

    border-bottom: 2px solid #d9dde1;

    text-transform: uppercase;

    box-shadow: 0 2px 0 #d9dde1;

}

.payments-table tbody td {

    padding: 11px 8px;

    vertical-align: middle;

    font-size: 12px;

    line-height: 1.45;

    background-color: #ffffff;

}

.payments-table tbody tr {

    transition: background-color 0.15s ease;

}

.payments-table tbody tr:hover td {

    background-color: #f8fafc !important;

}

.payment-row td:first-child {

    border-left: 4px solid #6c757d;

}

.id-column {

    width: 70px;

}

.data-column {

    width: 390px;

}

.amount-column {

    width: 140px;

}

.date-column {

    width: 160px;

}

.actions-column {

    width: 310px;

}

.payment-id-cell {

    font-size: 14px !important;

    font-weight: 700;

}

.payment-id {

    display: inline-flex;

    align-items: center;

    justify-content: center;

    min-width: 40px;

    min-height: 30px;

    padding: 4px 8px;

    color: #343a40;

    background-color: #f1f3f5;

    border-radius: 6px;

}

.payment-data-cell {

    color: #495057;

}

.payment-data-cell>span {

    display: block;

}

.payment-data-cell strong {

    color: #2f343a;

    font-weight: 600;

}

.payment-data-cell hr {

    margin: 9px 0;

    border-top-color: #e3e6e9;

}

.payment-amount-cell,

.amount-cell,

.pending-cell,

.paid-cell {

    font-size: 13px !important;

    font-weight: 600;

    font-variant-numeric: tabular-nums;

    white-space: nowrap;

}

.amount-payable-cell,

.pending-cell {

    color: #856404;

}

.amount-paid-cell,

.paid-cell {

    color: #1d7a36;

}

.payment-date-cell {

    font-size: 12px !important;

    color: #6c757d;

}

.actions-cell {

    padding: 9px !important;

}

.actions-wrap {

    display: flex;

    flex-wrap: wrap;

    gap: 5px;

    align-items: center;

    justify-content: center;

}

.actions-wrap .d-inline {

    display: contents !important;

}

.actions-wrap hr {

    flex: 0 0 100%;

    width: 100%;

    margin: 3px 0;

    border-top-color: #e1e5e9;

}

.actions-wrap .btn,

.actions-wrap a.btn {

    margin: 0 !important;

    padding: 5px 8px;

    border-radius: 6px;

    background-color: #ffffff;

    font-size: 11px;

    font-weight: 500;

    line-height: 1.3;

    white-space: normal;

    box-shadow: none;

}

.actions-wrap .btn-outline-light {

    color: #6c757d;

    border-color: #6c757d;

}

.actions-wrap .btn-outline-light:hover {

    color: #ffffff;

    background-color: #6c757d;

}

.table-state {

    height: 250px;

    padding: 0 !important;

}

.loading-state,

.empty-state {

    padding: 50px 20px;

    text-align: center;

}

.loading-state i,

.empty-state i {

    margin-bottom: 12px;

    font-size: 36px;

    color: #adb5bd;

}

.loading-state h5,

.empty-state h5 {

    margin-bottom: 4px;

    font-size: 15px;

    font-weight: 600;

    color: #343a40;

}

.loading-state p,

.empty-state p {

    margin-bottom: 0;

    font-size: 12px;

    color: #6c757d;

}

.totals-row td {

    position: sticky;

    bottom: 0;

    z-index: 4;

    padding: 12px 8px;

    font-weight: 700;

    color: #343a40;

    background-color: #e9ecef !important;

    border-top: 2px solid #ced4da;

    font-variant-numeric: tabular-nums;

}

.pagination-wrapper {

    display: flex;

    justify-content: flex-end;

    padding: 13px 16px;

    background-color: #ffffff;

    border-top: 1px solid #dee2e6;

}

.pagination-wrapper>>>.pagination {

    margin-bottom: 0;

}

.selected td {

    background-color: #f1f5ff !important;

}

.selected td:first-child {

    border-left-color: #4b72d9;

}

/* Modal de tipo de pago */

.btn-app {

    margin: 0;

    height: 80px;

}

.f-30 {

    font-size: 30px;

}

.payment-type-modal>>>.v--modal {

    border-radius: 8px;

    overflow: visible;

}

.payment-type-modal .modal-header {

    padding: 18px 20px 8px;

    border-bottom: 0;

}

.payment-type-modal .modal-title {

    margin-bottom: 0;

    font-size: 17px;

    font-weight: 600;

}

.modal-subtitle {

    margin: 4px 0 0;

    font-size: 12px;

    color: #6c757d;

}

.payment-type-modal .modal-body {

    padding: 10px 20px 20px;

}

.payment-type-modal .btn-closed {

    position: absolute;

    top: 10px;

    right: 10px;

    z-index: 4;

    width: 30px;

    height: 30px;

    padding: 0;

    border-radius: 50%;

}

.payment-option-btn {

    display: flex !important;

    flex-direction: column;

    align-items: center;

    justify-content: center;

    gap: 7px;

    height: 90px !important;

    border: 1px solid #dee2e6;

    border-radius: 8px;

    background-color: #f8f9fa;

    color: #343a40;

    font-size: 12px;

    font-weight: 600;

}

.payment-option-btn:hover {

    color: #0056b3;

    background-color: #eef5ff;

    border-color: #80bdff;

}

/* Responsive */

@media (max-width: 1199px) {

    .payments-summary {

        grid-template-columns: repeat(2, minmax(0, 1fr));

    }

    .payments-table-wrapper {

        height: auto;

        min-height: 0;

    }

}

@media (max-width: 767px) {

    .card-header {

        padding: 14px;

    }

    .card-body {

        padding: 14px;

    }

    .payments-actions {

        width: 100%;

        justify-content: flex-start;

    }

    .filters-panel {

        padding: 15px 15px 0;

    }

    .payments-summary {

        grid-template-columns: 1fr;

        gap: 10px;

    }

    .summary-card {

        min-height: 75px;

    }

    .pagination-wrapper {

        justify-content: center;

        overflow-x: auto;

    }

    .payments-table-wrapper {

        height: auto;

        min-height: 0;

    }

}

@media (max-width: 575px) {

    .payments-actions {

        display: grid;

        grid-template-columns: 1fr;

    }

    .payments-actions .btn {

        width: 100%;

    }

    .filters-heading {

        align-items: flex-start !important;

        flex-direction: column;

    }

    .default-period-badge {

        white-space: normal;

    }

}

/*  */

.bank-payment-card {

    min-width: 310px;

    max-width: 420px;

    padding: 12px;

    background-color: #ffffff;

    border: 1px solid #e2e8f0;

    border-left: 3px solid #138976;

    border-radius: 8px;

    color: #334155;

    white-space: normal;

    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);

}

.bank-payment-header {

    display: flex;

    align-items: center;

    gap: 10px;

    margin-bottom: 10px;

}

.bank-icon {

    display: flex;

    align-items: center;

    justify-content: center;

    flex: 0 0 34px;

    width: 34px;

    height: 34px;

    color: #138976;

    background-color: #e8f5f2;

    border-radius: 7px;

    font-size: 14px;

}

.bank-payment-title {

    display: flex;

    flex-direction: column;

    min-width: 0;

}

.bank-payment-title strong {

    overflow: hidden;

    color: #1e293b;

    font-size: 13px;

    line-height: 1.3;

    text-overflow: ellipsis;

    white-space: nowrap;

}

.bank-payment-label {

    display: block;

    margin-bottom: 2px;

    color: #64748b;

    font-size: 10px;

    font-weight: 600;

    line-height: 1.2;

    text-transform: uppercase;

    letter-spacing: 0.04em;

}

.bank-payment-badges {

    display: flex;

    flex-wrap: wrap;

    gap: 5px;

    margin-bottom: 10px;

}

.payment-badge {

    display: inline-flex;

    align-items: center;

    gap: 4px;

    max-width: 100%;

    padding: 4px 7px;

    border-radius: 5px;

    font-size: 10px;

    font-weight: 600;

    line-height: 1.2;

}

.payment-badge-category {

    color: #1e40af;

    background-color: #eff6ff;

    border: 1px solid #bfdbfe;

}

.payment-badge-movement {

    color: #92400e;

    background-color: #fffbeb;

    border: 1px solid #fde68a;

}

.bank-payment-grid {

    display: grid;

    grid-template-columns: repeat(2, minmax(0, 1fr));

    border-top: 1px solid #e2e8f0;

}

.bank-payment-item {

    min-width: 0;

    padding: 8px 6px;

    border-bottom: 1px solid #f1f5f9;

}

.bank-payment-item:nth-child(odd) {

    padding-left: 0;

    border-right: 1px solid #f1f5f9;

}

.bank-payment-item:nth-child(even) {

    padding-right: 0;

    padding-left: 10px;

}

.bank-payment-item strong {

    display: block;

    overflow: hidden;

    color: #334155;

    font-size: 11px;

    font-weight: 600;

    line-height: 1.35;

    text-overflow: ellipsis;

    white-space: nowrap;

}

.masked-account {

    color: #0f766e !important;

    font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;

    font-size: 12px !important;

    letter-spacing: 0.04em;

}

.empty-value {

    color: #94a3b8;

    font-size: 11px;

    font-style: italic;

}

.bank-payment-empty {

    padding: 10px;

    color: #64748b;

    background-color: #f8fafc;

    border: 1px dashed #cbd5e1;

    border-radius: 6px;

    font-size: 11px;

    text-align: center;

}

@media (max-width: 768px) {

    .bank-payment-card {

        min-width: 260px;

    }

    .bank-payment-grid {

        grid-template-columns: 1fr;

    }

    .bank-payment-item:nth-child(odd),

    .bank-payment-item:nth-child(even) {

        padding: 8px 0;

        border-right: 0;

    }

}


/* ==========================================================
   UX RESPONSIVO: UNA SOLA BARRA VERTICAL (LA DEL DOCUMENTO)
   No se modifican eventos Vue, botones, permisos ni datos.
   ========================================================== */
.payments-page,
.payments-page > .card,
.payments-page .card-body,
.payments-page .results-panel {
    min-width: 0;
    max-width: 100%;
}

.payments-table-wrapper {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow: visible !important;
}

/* Escritorio amplio: tabla sin ancho mínimo ni scroll anidado. */
.payments-table {
    width: 100%;
    min-width: 0 !important;
    table-layout: fixed;
}
.payments-table .id-column { width: 5%; }
.payments-table .data-column { width: 27%; }
.payments-table .amount-column { width: 11%; }
.payments-table .date-column { width: 12%; }
.payments-table .actions-column { width: 23%; }
.payments-table td,
.payments-table th {
    overflow-wrap: anywhere;
    word-break: normal;
}
.payments-table .payment-amount-cell {
    white-space: normal;
}
.payments-table .bank-payment-card {
    min-width: 0;
    max-width: 100%;
}
.payments-table .bank-payment-title strong,
.payments-table .bank-payment-item strong {
    white-space: normal;
    overflow-wrap: anywhere;
}

/*
  Hasta 1599 px: formato ficha administrativa.
  Se conserva el DOM de cada fila y todos sus botones originales.
  Los encabezados se generan con data-label en las celdas.
*/
@media (max-width: 1599px) {
    .payments-page .results-panel {
        padding: 12px;
        background: #f5f7fa;
        border: 1px solid #e2e8f0;
    }
    .payments-table,
    .payments-table thead,
    .payments-table tbody,
    .payments-table tfoot {
        display: block;
        width: 100%;
    }
    .payments-table { border: 0; background: transparent; }
    .payments-table thead { display: none; }
    .payments-table tbody .payment-row {
        display: grid;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        width: 100%;
        margin-bottom: 14px;
        overflow: hidden;
        background: #fff;
        border: 1px solid #dce3eb;
        border-radius: 10px;
        box-shadow: 0 2px 7px rgba(15, 23, 42, .04);
    }
    .payments-table tbody .payment-row > td {
        display: block;
        width: auto !important;
        min-width: 0;
        margin: 0;
        padding: 12px 14px !important;
        border: 0;
        border-bottom: 1px solid #edf1f5;
        overflow-wrap: anywhere;
        white-space: normal;
        text-align: left !important;
        vertical-align: top;
    }
    .payments-table tbody .payment-row > td::before,
    .payments-table tfoot .totals-row > td[data-label]::before {
        content: attr(data-label);
        display: block;
        margin-bottom: 6px;
        color: #64748b;
        font-size: 10px;
        font-weight: 700;
        line-height: 1.3;
        letter-spacing: .055em;
        text-transform: uppercase;
    }
    .payments-table tbody .payment-row > .payment-id-cell {
        grid-column: 1 / -1;
        display: flex;
        align-items: center;
        gap: 10px;
        border-left: 4px solid #6c757d;
        background: #f8fafc !important;
    }
    .payments-table tbody .payment-row > .payment-id-cell::before {
        margin-bottom: 0;
    }
    .payments-table tbody .payment-row > .payment-data-cell {
        grid-column: 1 / -1;
        line-height: 1.65;
    }
    .payments-table tbody .payment-row > .payment-amount-cell {
        grid-column: span 4;
        font-size: 13px !important;
        font-variant-numeric: tabular-nums;
    }
    .payments-table tbody .payment-row > .amount-payable-cell {
        background: #fffcf1 !important;
    }
    .payments-table tbody .payment-row > .amount-paid-cell {
        background: #f2fbf5 !important;
    }
    .payments-table tbody .payment-row > .payment-date-cell,
    .payments-table tbody .payment-row > .actions-cell {
        grid-column: 1 / -1;
    }
    .payments-table tbody .payment-row > .actions-cell {
        background: #fbfcfe !important;
        border-bottom: 0;
    }
    .payments-table .actions-wrap {
        justify-content: flex-start;
        align-items: stretch;
        gap: 7px;
    }
    .payments-table .actions-wrap .btn,
    .payments-table .actions-wrap a.btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        min-height: 35px;
        max-width: 100%;
        white-space: normal;
        text-align: center;
    }
    .payments-table .bank-payment-card { width: 100%; }
    .payments-table .bank-payment-title strong,
    .payments-table .bank-payment-item strong {
        white-space: normal;
        text-overflow: clip;
    }
    /* Cargando y sin resultados siguen ocupando el ancho completo. */
    .payments-table tbody:not(:has(.payment-row)) tr {
        display: block;
        width: 100%;
        background: #fff;
        border-radius: 10px;
    }
    .payments-table tbody:not(:has(.payment-row)) td {
        display: block;
        width: 100%;
    }
    .payments-table tfoot .totals-row {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0;
        margin-top: 4px;
        overflow: hidden;
        border: 1px solid #cbd5e1;
        border-radius: 10px;
        background: #e9ecef;
    }
    .payments-table tfoot .totals-row > td {
        display: block;
        width: auto;
        padding: 12px !important;
        border: 0;
        white-space: normal;
        overflow-wrap: anywhere;
        text-align: left !important;
        position: static;
    }
    .payments-table tfoot .totals-row > td:first-child {
        grid-column: 1 / -1;
        padding-bottom: 5px !important;
        border-bottom: 1px solid #cbd5e1;
    }
    .payments-table tfoot .totals-row > td:last-child { display: none; }
    .pagination-wrapper { flex-wrap: wrap; max-width: 100%; }
}

@media (max-width: 700px) {
    .payments-page .results-panel { padding: 8px; }
    .payments-table tbody .payment-row > td { padding: 12px !important; }
    .payments-table tbody .payment-row > .payment-amount-cell {
        grid-column: 1 / -1;
        border-right: 0;
    }
    .payments-table .actions-wrap .btn,
    .payments-table .actions-wrap a.btn { flex: 1 1 145px; }
    .payments-table tfoot .totals-row { grid-template-columns: 1fr; }
    .payments-table tfoot .totals-row > td:first-child { grid-column: 1; }
    .payments-table tfoot .totals-row > td:not(:last-child) {
        border-bottom: 1px solid #d7dee7;
    }
}

</style>